import React, { useMemo } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';


const buildOutlineTree = (raw) => {
  const text = String(raw || '').replace(/\t/g, '  ');
  const lines = text
    .split(/\r?\n/)
    .map(l => l.replace(/\s+$/g, '')) // trim end
    .filter(l => l.trim().length);

  const root = [];
  const stack = [{ level: -1, children: root }];

  for (const line of lines) {
    const leadingSpaces = (line.match(/^ */)?.[0]?.length) || 0;
    const level = Math.floor(leadingSpaces / 2);

    const trimmed = line.trim();
    const content = trimmed.replace(/^[-*•]\s+/, '').trim();
    if (!content) continue;

    while (stack.length && stack[stack.length - 1].level >= level) stack.pop();

    const node = { text: content, children: [] };
    stack[stack.length - 1].children.push(node);
    stack.push({ level, children: node.children });
  }

  return root;
};

const OutlineList = ({ nodes }) => {
  if (!nodes?.length) return null;
  return (
    <ul className="mb-0">
      {nodes.map((n, idx) => (
        <li key={`${n.text}-${idx}`}>
          {n.text}
          {!!n.children?.length && <OutlineList nodes={n.children} />}
        </li>
      ))}
    </ul>
  );
};

export default function ActionGuideModal({
  show,
  onHide,
  titleText,
  guideText,
  loading,
}) {
  const tree = useMemo(() => buildOutlineTree(guideText), [guideText]);

  return (
    <Modal show={show} onHide={onHide} centered scrollable size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Action Guide</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {titleText ? <div className="mb-2"><strong>{titleText}</strong></div> : null}

        {loading ? (
          <div className="d-flex justify-content-center my-3">
            <Spinner animation="border" size="sm" />
          </div>
        ) : (String(guideText || '').trim() ? (
          <OutlineList nodes={tree} />
        ) : (
          <div className="text-muted">
            No action guide is configured for this Type / Category.
          </div>
        ))}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="primary" onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}